import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=fd59fd6c&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd59fd6c')) {
      api.createRecord('fd59fd6c', component.options)
    } else {
      api.reload('fd59fd6c', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=fd59fd6c&", function () {
      api.rerender('fd59fd6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2lviGwdVBc1RW/JS/comp/IncreaseNumber.vue"
export default component.exports